import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
}); 


export class DashboardLayoutsAPI {

    // Function to create a new dashboard layout
    static async newDashboardLayout(data, token) {
        const res = await server('/dashboard-layout', {
            method: 'POST',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Function to get the dashboard layout of the authenticated user (the server identifies the owner from the token)
    static async getDashboardLayouts({business_code, dashboard_key = 'overview', token}) {
        const res = await server(`/dashboard-layout?business_code=${encodeURIComponent(business_code)}&dashboard_key=${encodeURIComponent(dashboard_key)}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Function to get the default Overview template (available even if the user already saved their own)
    static async getDefaultTemplate(token) {
        const res = await server('/dashboard-layout/default', {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Function to update an existing dashboard layout
    static async updateDashboardLayout(id, data, token) {
        const res = await server(`/dashboard-layout/${id}`, {
            method: 'PUT',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }
    
} 